export default __webpack_public_path__ + "static/media/pnsv_stand_Marva.12dff6ff.png";